import { useState } from "react";

export default function ProductList() {

    const products = [
        {
            id: 1,
            name: "Tanganil 500mg pierre fabre (h/30v)",
            max: 155,
            image: "https://gcs.buymed.com/thuocsi-live/images/2025006a022ff94e383c306624780ad5?width=150&quality=80",
        },
        {
            id: 2,
            name: "Xịt mũi Otosan Nasal Spray Forte (C/30ml)",
            max: 82,
            image: "https://gcs.buymed.com/thuocsi-live/images/2025f064096aab6c1462c24a979b6b16?width=150&quality=80",
        },
        {
            id: 3,
            name: "Enervon c united pharma (h/100v)",
            max: 220,
            image: "https://gcs.buymed.com/thuocsi-live/images/20255561b82d73941e54da23fae06cf4?width=150&quality=80",
        },
    ];

    const [qty, setQty] = useState<QuantityState>(
        products.reduce((acc, p) => ({ ...acc, [p.id]: 0 }), {} as QuantityState)
    );

    interface Product {
        id: number;
        name: string;
        max: number;
        image: string;
    }

    interface QuantityState {
        [key: number]: number;
    }

    interface LikedState {
        [key: number]: boolean;
    }

    const increase = (id: number, max: number): void => {
        setQty((prev: QuantityState) => ({
            ...prev,
            [id]: Math.min((prev[id] || 0) + 1, max)
        }));
    };

    const decrease = (id: number): void => {
        setQty((prev: QuantityState) => ({
            ...prev,
            [id]: Math.max((prev[id] || 0) - 1, 0)
        }));
    };

    const changeInput = (id: number, max: number, value: string): void => {
        const v = Number(value);
        if (isNaN(v)) return;
        setQty(prev => ({
            ...prev,
            [id]: Math.max(0, Math.min(v, max))
        }));
    };

    // LIKE state
    const [liked, setLiked] = useState<LikedState>(
        products.reduce((acc, p) => ({ ...acc, [p.id]: false }), {} as LikedState)
    );

    const toggleLike = (id: number) => {
        setLiked(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    return (
        <div className="styles_listProducts__nQnSb">

            {products.map(product => (
                <div className="styles_cardWrapper__DC_WP" key={product.id}>
                    <div className="MuiPaper-root MuiCard-root styles_card__wBpbF MuiPaper-elevation1 MuiPaper-rounded">

                        {/* ❤️ wishlist button */}
                        <div
                            className="styles_cardWishList__xjQ_X"
                            onClick={() => toggleLike(product.id)}
                            role="button"
                            style={{ cursor: "pointer" }}
                        >
                            <img
                                src={
                                    liked[product.id]
                                        ? "https://cdn-web-next.thuocsi.vn/icons/wish_list_active.svg"
                                        : "https://cdn-web-next.thuocsi.vn/icons/wish_list_inactive.svg"
                                }
                                alt="wishlist"
                            />
                        </div>

                        {/* IMAGE */}
                        <div className="styles_cardImage__NDRZc">
                            <img
                                className="styles_image__j5quc"
                                src={product.image}
                                alt={product.name}
                            />
                        </div>

                        {/* TITLE */}
                        <div className="MuiCardContent-root styles_cardDesc__EzCGV">
                            <a className="styles_cardTitle__cU0KJ">
                                <span>{product.name}</span>
                            </a>
                            <div className="styles_cardStore__F6qYF MuiBox-root css-0">
                                <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", position: "relative", maxWidth: "100%" }}>
                                    <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                                        <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2713%27%20height=%2713%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px" }} />
                                    </span>
                                    <img src="https://cdn-web-next.thuocsi.vn/icons/seller_store.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: "0px", boxSizing: "border-box", padding: "0px", border: "none", margin: "auto", display: "block", width: "0px", height: "0px", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} />
                                </span>
                                <a className="styles_cardNameStore__a_Oks" target="_blank" href="/seller-products/cong-ty-tnhh-duoc-pham-medx">MEDX</a>
                            </div>
                            <div className="styles_cardBadges__JMC4V MuiBox-root css-0">
                                <a className="styles_mobile_rootBase__8z7PQ" target="_blank" href="/tag/buymed-tro-gia">
                                    <img alt="tag-/tag/buymed-tro-gia" src="https://gcs.buymed.com/thuocsi-live/internal/cms/20251527be53d636c56bbe14b225636aGroup_1000004196.svg" />
                                </a>
                                <a className="styles_mobile_rootBase__8z7PQ" target="_blank" href="/tag/hang-benh-vien">
                                    <img alt="tag-/tag/hang-benh-vien" src="https://gcs.buymed.com/thuocsi-live/internal/cms/2025d21b298a54cabd59e161251ff9f3Group_1000004190_(2).svg" />
                                </a>
                            </div>
                        </div>

                        <div className="MuiCardContent-root styles_cardPrice__Phq1m">
                            <div className="styles_cardPriceItem__0Z9Ac MuiBox-root css-0">
                                <a className="styles_cardCurrentPrice__FRdV0" href="/product/medx-tanganil-500mg--pierre-fabre-h30v">
                                    <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                        <div className="styles_canvasPrice__vw932" style={{ height: "30px" }}>
                                            155.000đ
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                        {/* MAX ORDER */}
                        <div className="styles_cardActions__4sm0A MuiCardActions-root MuiCardActions-spacing">
                            <div className="styles_cardActionsItem__PKAZb">
                                <span className="styles_cardNoted__s14eQ">
                                    Đặt tối đa {product.max} sản phẩm
                                </span>
                            </div>

                            {/* QUANTITY CONTROL */}
                            <div className="styles_cardActionsItem__PKAZb">
                                <div className="styles_maxWidth__qS6it">
                                    <div className="styles_container___oLk_ styles_quantityControlContainer__tKXM0">

                                        {/* minus */}
                                        <div
                                            className="styles_minusContainerNew__flGSc qty-control-viewed-minus"
                                            role="button"
                                            onClick={() => decrease(product.id)}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M7 12H17" stroke="#333333" stroke-width="2" stroke-linecap="round"></path></svg>
                                        </div>

                                        <div className="styles_groupInput__H1lLR qty-control-viewed-input-group">
                                            <div className="styles_cartIconContainer__FoKUV">
                                                <div className="styles_inputVisible__m_CzR">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path d="M14.3608 3.9375H4.00136L3.11622 2.35095C3.01687 2.17287 2.82892 2.0625 2.625 2.0625H1.5C1.18934 2.0625 0.9375 2.31434 0.9375 2.625C0.9375 2.93566 1.18934 3.1875 1.5 3.1875H2.2947L3.16822 4.75324L5.18278 9.21066L5.18484 9.21521L5.36228 9.60781L3.33965 11.7653C3.19422 11.9204 3.14869 12.1443 3.22199 12.3439C3.29529 12.5435 3.47488 12.6847 3.68614 12.7089L5.52974 12.9196C7.83575 13.1831 10.1643 13.1831 12.4703 12.9196L14.3139 12.7089C14.6225 12.6736 14.8442 12.3948 14.8089 12.0861C14.7736 11.7775 14.4948 11.5559 14.1861 11.5911L12.3425 11.8018C10.1214 12.0557 7.87861 12.0557 5.65749 11.8018L4.92585 11.7182L6.41038 10.1347C6.42474 10.1194 6.43808 10.1035 6.45039 10.0871L7.015 10.1605C7.8062 10.2635 8.60596 10.2837 9.40134 10.2208C11.2564 10.074 12.9758 9.19131 14.1761 7.7693L14.6097 7.25569C14.6242 7.23844 14.6377 7.22033 14.6501 7.20146L15.4581 5.97007C16.0309 5.09724 15.4048 3.9375 14.3608 3.9375Z" fill="#999999"></path>
                                                        <path d="M4.875 13.875C4.25368 13.875 3.75 14.3787 3.75 15C3.75 15.6213 4.25368 16.125 4.875 16.125C5.49632 16.125 6 15.6213 6 15C6 14.3787 5.49632 13.875 4.875 13.875Z" fill="#999999"></path>
                                                        <path d="M12 15C12 14.3787 12.5037 13.875 13.125 13.875C13.7463 13.875 14.25 14.3787 14.25 15C14.25 15.6213 13.7463 16.125 13.125 16.125C12.5037 16.125 12 15.6213 12 15Z" fill="#999999"></path>
                                                    </svg>
                                                </div>
                                                <span className="styles_currentValue__b2ijJ">{qty[product.id]}</span>
                                            </div>
                                            <div className="MuiInput-root MuiInputBase-root MuiInputBase-colorPrimary styles_newCardInput__hecWu qty-control-viewed-input css-1f63zq5">
                                                <input
                                                    type="number"
                                                    className="MuiInput-input MuiInputBase-input css-mnn31"
                                                    value={qty[product.id]}
                                                    onChange={(e) =>
                                                        changeInput(
                                                            product.id,
                                                            product.max,
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        {/* plus */}
                                        <div
                                            className="styles_addContainerNew__v_8_6"
                                            role="button"
                                            onClick={() => increase(product.id, product.max)}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M12 17V7" stroke="#005c29" stroke-width="2" stroke-linecap="round"></path><path d="M7 12L17 12" stroke="#005c29" stroke-width="2" stroke-linecap="round"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            ))}
        </div>
    );
}
